import { Branding, BrandingDisabledIf, DisabledPrompt, useModel } from "bcms-react";
import { MainNavItem, MainNavMenuItem } from "../..";
import "./styles.css";

/**
 * @name BID2132PMainNavItems
 * @function
 * @extends React.Component
 * @exported true
 * @description The main component for navigation for BID 2132P.
 * @example
 * export default function Component() {
 *  return (
 *      <div>
 *          <BID2132PMainNavItems/>
 *      </div>
 *  );
 * }
 */
export default function BID2132PMainNavItems(props) {
  const { branding, demos } = useModel();
  const { options } = branding;
  const openAccount = () => {
    let origVersion = branding.options.orig_version_abi22;
    if (origVersion !== "ORIG19") origVersion = "ORIG20";
    window.open(demos[origVersion], "_blank");
  };

  const newAccountsLink = <MainNavItem label="Accounts" data-point="Nav_Accounts" activeRoutes={["/accountSummary"]}>
    <MainNavMenuItem label="Account Summary" route="/accountSummary" data-point="Nav_Account_Summary" />
    <DisabledPrompt>
      <MainNavMenuItem label="eStatements" data-point="Nav_eStatements_Notices" />
    </DisabledPrompt>
    <DisabledPrompt>
      <MainNavMenuItem label="Mortgage Accounts" data-point="Nav_eStatements_Notices" />
    </DisabledPrompt>
    <BrandingDisabledIf id="orig_courseid_abi22" exp={value => value !== null && value !== undefined}>
      <MainNavMenuItem label="Open a New Account" data-point="Nav_Open_Account" onClick={openAccount} />
    </BrandingDisabledIf>
    <MainNavMenuItem label="Apply For" data-point="Nav_Apply_For">
      <DisabledPrompt>
        <MainNavMenuItem label="Apply for a Mortgage" data-point="Nav_Apply_for_a_Mortgage" />
      </DisabledPrompt>
      <DisabledPrompt>
        <MainNavMenuItem label="Apply for a Loan" data-point="Nav_Apply_for_a_Loan" />
      </DisabledPrompt>
      <DisabledPrompt>
        <MainNavMenuItem label="Apply for a Credit Card" data-point="Nav_Apply_for_a_Credit_Card" />
      </DisabledPrompt>
    </MainNavMenuItem>
    <DisabledPrompt>
      <MainNavMenuItem label="Relationship Builder" data-point="Nav_Relationship_Builder" />
    </DisabledPrompt>
    <DisabledPrompt>
      <MainNavMenuItem label="Commercial Banking" data-point="Nav_Commercial_Banking" />
    </DisabledPrompt>
    <DisabledPrompt>
      <MainNavMenuItem label="Fee Schedule" data-point="Nav_Fee_Schedule" />
    </DisabledPrompt>
  </MainNavItem>;
  const newTransfersLink = <MainNavItem label="Transfers" data-point="Nav_Transfers" activeRoutes={["/transfers", "/externalTransfers", "/transferActivity/scheduledTransfers", "/unlinkedTransferAccounts"]} >
    <MainNavMenuItem label="Make a Transfer" route="/transfers" data-point="Nav_Make_Transfer" />
    <MainNavMenuItem label="Transfer Activity" route="/transferActivity/scheduledTransfers" data-point="Nav_Transfer_Activity" />
    <MainNavMenuItem label="External Transfers" route="/externalTransfers" data-point="Nav_External_Transfers" />
    <MainNavMenuItem label="Other NFCU Accounts" route="/unlinkedTransferAccounts" data-point="Nav_Transfer_Accounts" />
    <DisabledPrompt>
      <MainNavMenuItem label="In-Branch Transactions" data-point="Nav_In_Branch_Transactions" />
    </DisabledPrompt>
  </MainNavItem>;

  const paymentLink = <MainNavItem label="Payments" data-point="Nav_Payments" activeRoutes={["payments", "/stopPayment"]}>
    <MainNavMenuItem label="Bill Payment Center" route="/payments" data-point="Nav_Pay_Bills" />
    <MainNavMenuItem label="Loan Payment Center" data-point="Nav_Loan_Payment_Center">
      <DisabledPrompt>
        <MainNavMenuItem label="Pay with External Account" data-point="Nav_Pay_with_External_Account" />
      </DisabledPrompt>
      <MainNavMenuItem label="Pay with NFCU Account" route="/transfers" data-point="Nav_Pay_with_NFCU_Account" />
    </MainNavMenuItem>
    <MainNavMenuItem label="Stop Payment" route="/stopPayment" data-point="Nav_Stop_Payments" />
    <DisabledPrompt>
        <MainNavMenuItem label="Skip A Pay" data-point="Nav_Skip_A_Pay" />
      </DisabledPrompt>
  </MainNavItem>;

  const pfmLink = options.pfm21_courseID_abi22 === null
    ? <DisabledPrompt><MainNavItem label="My Finances" data-point="Nav_My_Finances" /></DisabledPrompt>
    : <MainNavItem label="My Finances" route="/myFinances" data-point="Nav_My_Finances" />;

  const zleMainNavItem = <MainNavItem label={<>Send Money with Zelle<span className="r-mark">&reg;</span></>} route="/zelle" data-point="Nav_Zelle" />;







  // END: Branded links declared here and returned in the component.

  return (
    <Branding id="bid_abi22" value="2132P">
      <div className="flex-container flex-horizontal bid-2132P-menu">
        {newAccountsLink}
        {newTransfersLink}
        {paymentLink}
        {pfmLink}
        {zleMainNavItem}
      </div>
    </Branding>
  );
}
